import useGlobalDialog from './useGlobalDialog';

export interface useAdvertCreateWizardProps {}

const useAdvertCreateWizard = () =>
  useGlobalDialog<useAdvertCreateWizardProps>('advertCreateWizard');
export default useAdvertCreateWizard;
